import { AuthService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

export interface PListOrderDto {
  id: number;
  companyNo: string;
  pListID: number;
  orderNo: number;
  numOfPackages?: number | null;
  totalVolume?: number | null;
  totalWeight?: number | null;
  packageRemark?: string | null;
  packZoneID?: string | null;
  carrierName?: string | null;
  numOfPallets?: number | null;
}

export interface UpdatePListOrderRequest {
  numOfPackages?: number | null;
  totalVolume?: number | null;
  totalWeight?: number | null;
  packageRemark?: string | null;
  packZoneID?: string | null;
  carrierName?: string | null;
  numOfPallets?: number | null;
}

class PListOrderService {
  /**
   * Get all PListOrders for a specific PList
   */
  async getByPListId(companyNo: string, pListId: number): Promise<PListOrderDto[]> {
    const url = `${API_BASE_URL}/plist-orders/plist/${companyNo}/${pListId}`;
    const response = await AuthService.authenticatedGet(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch PListOrders: ${response.statusText}`);
    }

    return response.json();
  }

  /**
   * Update an existing PListOrder
   */
  async update(
    companyNo: string,
    pListId: number,
    orderNo: number,
    request: UpdatePListOrderRequest
  ): Promise<PListOrderDto> {
    const url = `${API_BASE_URL}/plist-orders/${companyNo}/${pListId}/${orderNo}`;
    const response = await AuthService.authenticatedPut(url, request);

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: response.statusText }));
      throw new Error(error.error || `Failed to update PListOrder: ${response.statusText}`);
    }

    return response.json();
  }
}

export const plistOrderService = new PListOrderService();
